export const RESET_STATE = 'cx-ray/RESET';

export const resetState = () => ({
  type: RESET_STATE
});
